import { MultinomialNB } from "ml-naivebayes";
import { stateTypeF } from "../state";
import { BaseModel } from "./BaseModel";

import { ALL_MODELS, MODEL_STATES } from "../constants";
import { dataSplit, infoType } from "./Dataset";

export class NaiveBayes extends BaseModel {
  modelName = ALL_MODELS.bayes;
  maxElements = 50000;
  options = {
    seed: 3,
    replacement: false,
    nEstimators: 200,
  };

  model: MultinomialNB;
  modelState = MODEL_STATES.ready;

  constructor(mlDataInfo: infoType) {
    super(mlDataInfo);
    this.initModel();
  }

  initModel() {
    this.model = new MultinomialNB();
  }

  async train(
    trainData: dataSplit,
    state: stateTypeF,
    callbackFunction: Function
  ) {
    state.setModelState(
      this.modelName,
      MODEL_STATES.training,
      state.saveState.modelTraining.modelStates
    );
    BaseModel.setModelProgress(0, state, this.modelName);
    this.model.train(trainData.xTrain, trainData.yTrain);
    this.isBestModel(trainData.xTest, trainData.yTest);
    BaseModel.setModelProgress(100, state, this.modelName);
    state.setModelState(
      this.modelName,
      MODEL_STATES.trained,
      state.saveState.modelTraining.modelStates
    );
  }

  predict(X: number[][]) {
    let output: number[] = this.model.predict(X);
    return output;
  }

  predictProbs(X: number[][]) {
    let probs: number[][] = this.model.predictProbs(X);
    return probs;
  }
}
